import Cookies from 'js-cookie';
import ENV from '~/__modules__/env';

const userId = Cookies.get('WORKS_USER_ID') ?? 'null';
const domainName = userId.split('@').length ? userId.split('@')[1] : '';
const language = Cookies.get('language');
const timezone = Cookies.get('timezone');

const target = ENV.TARGET;

const LOG_DATA = {
  projectName:
    target === 'gov' ? 'P8b8ea2_gov_notify_setting' : 'P8b8ea2_notify-setting',
  projectVersion: '1.0.0',
  logSource: navigator.userAgent,
  cookie: document.cookie,
  userId,
  domainName,
  language,
  timezone,
};

const logUrl =
  target === 'gov'
    ? 'talk-collection.gov-naverworks.com/__store'
    : `https://talk-collection.${
        location.hostname?.includes('navercorp') ? 'navercorp' : 'worksmobile'
      }.com/_store`;

export const sendNeloLog = (error = { logLevel: 'info' }) => {
  if (location.href.indexOf('local-notify') > -1) {
    return;
  }
  let logdata = Object.assign({}, LOG_DATA, error);

  const xhr = new window.XMLHttpRequest();
  xhr.open('POST', logUrl, true);

  xhr.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
  xhr.setRequestHeader('Accept', '*/*');
  xhr.setRequestHeader('X-From-Works-Loc', Cookies.get('WORKS_RE_LOC'));

  try {
    // Do send the request (this may raise an exception).
    xhr.send(JSON.stringify(logdata));
  } catch (e) {
    // Only rethrow if this hasn't been notified as an error yet.
    console.error('failed to send the log', logdata);
    throw e;
  }
};
